export const TRANSACTION_VALIDATION_ERROR = {
  PENDING_TRANSACTION: 'PENDING_TRANSACTION',
};
